/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_Hint_InspectorInputs */

const en_image_inspector_hint_inspector = /** @type {(inputs: Image_Inspector_Hint_InspectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`inspector`)
};

const ar_image_inspector_hint_inspector = /** @type {(inputs: Image_Inspector_Hint_InspectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفاحص`)
};

const bn_image_inspector_hint_inspector = /** @type {(inputs: Image_Inspector_Hint_InspectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ইন্সপেক্টর`)
};

const de_image_inspector_hint_inspector = /** @type {(inputs: Image_Inspector_Hint_InspectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspektor`)
};

const es_image_inspector_hint_inspector = /** @type {(inputs: Image_Inspector_Hint_InspectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspector`)
};

const fr_image_inspector_hint_inspector = /** @type {(inputs: Image_Inspector_Hint_InspectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspecteur`)
};

const pt_image_inspector_hint_inspector = /** @type {(inputs: Image_Inspector_Hint_InspectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspetor`)
};

const zh_image_inspector_hint_inspector = /** @type {(inputs: Image_Inspector_Hint_InspectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检查器`)
};

const tr_image_inspector_hint_inspector = /** @type {(inputs: Image_Inspector_Hint_InspectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denetçi`)
};

const ru_image_inspector_hint_inspector = /** @type {(inputs: Image_Inspector_Hint_InspectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Инспектор`)
};

const pl_image_inspector_hint_inspector = /** @type {(inputs: Image_Inspector_Hint_InspectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspektor`)
};

/**
* | output |
* | --- |
* | "inspector" |
*
* @param {Image_Inspector_Hint_InspectorInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_hint_inspector = /** @type {((inputs?: Image_Inspector_Hint_InspectorInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_Hint_InspectorInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_hint_inspector(inputs)
	if (locale === "bn") return bn_image_inspector_hint_inspector(inputs)
	if (locale === "de") return de_image_inspector_hint_inspector(inputs)
	if (locale === "es") return es_image_inspector_hint_inspector(inputs)
	if (locale === "fr") return fr_image_inspector_hint_inspector(inputs)
	if (locale === "pt") return pt_image_inspector_hint_inspector(inputs)
	if (locale === "zh") return zh_image_inspector_hint_inspector(inputs)
	if (locale === "tr") return tr_image_inspector_hint_inspector(inputs)
	if (locale === "ru") return ru_image_inspector_hint_inspector(inputs)
	if (locale === "pl") return pl_image_inspector_hint_inspector(inputs)
	return en_image_inspector_hint_inspector(inputs)
});